import React from 'react'
import { EloIconProps } from '@elo-ui/components/icons/product-types/types'

export const EloMonduIcon: React.FC<EloIconProps> = ({ width = 97, height = 40 }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 97 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-label='Mondu'
  >
    <path
      d='M91.6703 0H5.32967C2.38617 0 0 2.36678 0 5.28634V34.7137C0 37.6332 2.38617 40 5.32967 40H91.6703C94.6138 40 97 37.6332 97 34.7137V5.28634C97 2.36678 94.6138 0 91.6703 0Z'
      fill='#8B4AFF'
    />
    <path d='M84.0311 9.29515H12.9689V26.9163H84.0311V9.29515Z' fill='#8B4AFF' />
    <path
      d='M46.7037 26.4844V14.5548H49.5615V16.1471C50.3215 14.9079 51.7166 14.1673 53.2034 14.2118C56.2126 14.2118 57.6548 16.3192 57.6548 18.9396V26.4855H54.7211V19.4303C54.7211 17.9614 54.0381 16.7844 52.1924 16.7844C50.5221 16.7844 49.6382 18.0335 49.6382 19.6014V26.4844H46.7037Z'
      fill='white'
    />
    <path
      d='M77.7594 26.8275C74.8259 26.8275 73.1053 24.72 73.1053 22.0752V14.5537H76.0388V21.56C76.0388 23.0289 76.7473 24.2793 78.5172 24.2793C80.2872 24.2793 81.0977 23.1778 81.0977 21.6088V14.5537H84.0311V24.3026C84.0311 25.2819 83.9807 26.0425 84.0311 26.4833H81.2489C81.2236 26.0425 81.2236 25.6005 81.2489 25.1609C80.6425 26.2389 79.2003 26.8264 77.7583 26.8264'
      fill='white'
    />
    <path
      d='M27.1216 14.2106C25.4847 14.1218 23.9371 14.9379 23.1256 16.3181C22.4457 14.9579 20.9898 14.1274 19.4332 14.2106C17.967 14.1729 16.5868 14.8791 15.7912 16.0727V14.5548H12.9689L12.9838 26.4844H15.8944V19.4048C15.8944 17.8858 16.8814 16.7589 18.4485 16.7589C20.1186 16.7589 20.8259 17.837 20.8259 19.2083V26.4844H23.7067V19.4048C23.6127 18.0381 24.6789 16.8566 26.09 16.7644C26.1474 16.7611 26.2035 16.7589 26.2609 16.7589C27.9047 16.7589 28.6383 17.8115 28.6383 19.2083V26.4844H31.471V18.7408C31.471 15.5808 29.3468 14.2095 27.1206 14.2095'
      fill='white'
    />
    <path
      d='M71.3536 9.29515L68.3685 10.2401V15.9506C67.9892 15.1911 66.9023 14.2362 64.7518 14.2362C61.2841 14.2362 58.8849 17.0531 58.8849 20.4807C58.8849 24.0816 61.2623 26.7787 64.8022 26.7787C66.2615 26.8419 67.6429 26.1401 68.4179 24.941V26.4844H71.3513C71.3261 26.289 71.3513 25.3829 71.3513 24.3036V9.29515H71.3536ZM65.1325 24.2793C63.1344 24.2793 61.8194 22.7604 61.8194 20.4819C61.8194 18.2035 63.2364 16.7555 65.1577 16.7555C67.0789 16.7555 68.395 18.1767 68.395 20.4552C68.395 22.7336 67.0549 24.277 65.1325 24.277'
      fill='white'
    />
    <path
      d='M39.0919 14.2517C35.4247 14.2517 32.7194 16.9221 32.7194 20.5718C32.7194 24.2215 35.426 26.9163 39.0919 26.9163C42.758 26.9163 45.4909 24.246 45.4909 20.5718C45.4909 16.8977 42.7843 14.2517 39.0919 14.2517ZM42.2593 21.7632C42.2478 22.3473 41.8512 22.858 41.2746 23.0312L36.1091 24.6689C36.0449 24.689 35.9762 24.6544 35.9556 24.5924C35.952 24.5801 35.9497 24.5679 35.9497 24.5558V19.4014C35.96 18.8174 36.3579 18.3055 36.9344 18.1336L42.101 16.498C42.1653 16.478 42.2341 16.5124 42.2547 16.5746C42.2581 16.5868 42.2604 16.599 42.2604 16.6112V21.7642L42.2593 21.7632Z'
      fill='white'
    />
  </svg>
)
